var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrabHandleDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 8.208,
    height: 15.532,
    viewBox: "0 0 8.208 15.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "grab_handle-dots_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.208,
    height: 15.532,
    fill: "#979797"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#grab_handle-dots_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.035,244.07A1.035,1.035,0,1,0,0,243.035a1.036,1.036,0,0,0,1.035,1.035",
    transform: "translate(0 -228.537)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.035,123.469A1.035,1.035,0,1,0,0,122.435a1.036,1.036,0,0,0,1.035,1.035",
    transform: "translate(0 -114.646)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.035,2.87A1.035,1.035,0,1,0,0,1.835,1.036,1.036,0,0,0,1.035,2.87",
    transform: "translate(0 -0.755)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.367,243.27a1.035,1.035,0,1,0-1.035-1.035,1.036,1.036,0,0,0,1.035,1.035",
    transform: "translate(-104.194 -227.782)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.367,122.67a1.035,1.035,0,1,0-1.035-1.035,1.036,1.036,0,0,0,1.035,1.035",
    transform: "translate(-104.194 -113.892)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.367,2.07a1.035,1.035,0,1,0-1.035-1.035,1.036,1.036,0,0,0,1.035,1.035",
    transform: "translate(-104.194)",
    fill: "#979797"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrabHandleDots);
export default __webpack_public_path__ + "static/media/grab_handle-dots.2fb5c9ea42b7ccc56b891562f43a284b.svg";
export { ForwardRef as ReactComponent };